import { Component, Input, OnInit, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';

export enum seasonTranslates {
  "زمستان" = 'winter',
  "پاییز" = 'autumn' ,
  "تابستان" = 'summer',
  "بهار" = 'spring',
}
 
@Component({
  selector: 'iho-season-tips',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './season-tips.component.html',
  styleUrls: ['./season-tips.component.scss'],
})
export class SeasonTipsComponent implements OnInit {

  @Input() season!: string | number
  @Input() content!: string
  @Input() seasonNote!: any
  @Input() hotelName!: any
  @Input() nowruz!: boolean
  @Input() nowruzDescription!: any

  seasons = [
    {},
    {
      en: 'spring',
      fa: "بهار"
    },
    {
      en: 'summer',
      fa: "تابستان",
    },
    {
      en: 'autumn',
      fa: "پاییز"
    },
    {
      en: 'winter',
      fa: "زمستان",
    },
  ]

  seasonTranslate: any = seasonTranslates

  ngOnInit(): void {
    
  }
}
